import React from 'react';
import {graphql} from 'gatsby';
import {Helmet} from 'react-helmet';
import Hero from '../components/Hero/Hero';
import Section from '../components/Section/Section';
import AnchorLink from 'react-anchor-link-smooth-scroll';
import './index.less';

const IndexPage = ({pageContext, data}) => {
    const fireEdapEvent = (ctaObj) => {
        if (typeof window !== 'undefined') {
            window.edap.push((edap) => {
                edap.trigger('generic.event', {
                    eventcategory: 'travel-with-confidence',
                    eventaction: 'link.click',
                    eventlabel: ctaObj.edapLabel,
                });
            });
        }
    };

    const handleClick = (cta) => fireEdapEvent(cta);

    const page = JSON.parse(data.sheets.jsonPayload).content;
    page.jumpnav.forEach((link) => {
        link.node = <AnchorLink href={link.href}>{link.label}</AnchorLink>;
    });

    const insuranceUrl = page.sections[3].cta.url;

    return (
        <>
            <Helmet title={page.meta.title} />
            <Hero
                title={page.hero.headline}
                copy={page.hero.copy}
                paths={pageContext.routes}
                jumpLinks={page.jumpnav}
            />
            <Section {...page.sections[0]} image="luggage" id="before" />
            <Section {...page.sections[1]} image="pool" id="during" />
            <Section {...page.sections[2]} image="photos" id="after" />
            <div className="content-container bwc">
                <img
                    src={require('../assets/badge.png')}
                    alt=""
                    className="img-responsive"
                />
                <h3>{page.bwc.headline}</h3>
                <div className="bwc__buttons">
                    <a
                        href={page.bwc.help.url}
                        className="btn btn-primary btn-sm"
                        onClick={() => {
                            handleClick(page.bwc.help);
                        }}
                    >
                        {page.bwc.help.label}
                    </a>
                    {!!page.bwc.terms.url && (
                        <a
                            href={page.bwc.terms.url}
                            className="btn btn-link btn-sm"
                            onClick={() => {
                                handleClick(page.bwc.terms);
                            }}
                        >
                            {page.bwc.terms.label}
                        </a>
                    )}
                </div>
            </div>
            {insuranceUrl && <Section {...page.sections[3]} id="insurance" />}
        </>
    );
};

export default IndexPage;

export const ContentQuery = graphql`
    query {
        sheets {
            jsonPayload
        }
    }
`;
